import { writable } from 'svelte/store';

type LayoutStore = 'menu' | 'search' | null;

const createLayoutPanelStore = () => {
  const { subscribe, set, update } = writable<LayoutStore>(null);

  let timeout: NodeJS.Timeout;

  const setValue = (valueOrUpdater: LayoutStore | ((curr: LayoutStore) => LayoutStore)) => {
    if (timeout) clearTimeout(timeout);

    typeof valueOrUpdater === 'function' ? update(valueOrUpdater) : set(valueOrUpdater);
  };

  const toggle = (value: LayoutStore) => {
    setValue((curr) => (curr === value ? null : value));
  };

  const open = (value: LayoutStore) => {
    setValue(value);
  };

  const close = (options: { timeout?: number } = {}) => {
    timeout = setTimeout(() => {
      setValue(null);
    }, options.timeout || 0);
  };

  return {
    subscribe,
    toggle,
    open,
    close
  };
};

export const layoutPanel = createLayoutPanelStore();
